import React from "react";
import { useUser } from "@/app/providers";
import { string, object } from "prop-types";
import { useUpdateProfile } from "@/hooks";
import { TenantDropdown } from "@/components";

type TenantDropdownAutoSaveProps = {
  componentLabel?: string;
  sx?: Record<string, unknown>;
};

type TenantChangeEvent = {
  label?: string;
  value?: string | number;
};

/**
 * Customer dropdown component
 * @param {object} props props
 * @returns {React.JSX.Element} React Component
 * @class
 */
export const TenantDropdownAutoSave = (props: TenantDropdownAutoSaveProps) => {
  const { updateProfile } = useUpdateProfile();
  const { user, setUser } = useUser();
  const { currentTenantId } = user || {};

  const handleChange = (event: TenantChangeEvent) => {
    if (event.value && event.value !== currentTenantId && event.value !== "") {
      const variables = {
        currentTenantId: String(event.value),
      };
      const updatedUser = {
        ...user,
        ...variables,
      };
      setUser(updatedUser);
      updateProfile(variables);
    }
  };

  return (
    <TenantDropdown
      defaultValue={currentTenantId}
      onChange={handleChange}
      componentLabel={props.componentLabel}
      cacheKey="AppBar"
      required
      sx={{
        ...props.sx,
      }}
    />
  );
};

TenantDropdownAutoSave.propTypes = {
  componentLabel: string,
  sx: object,
};
